
interface ProductionCheckResult {
  isReady: boolean;
  issues: string[];
  warnings: string[];
}

export const checkProductionReadiness = (): ProductionCheckResult => {
  const issues: string[] = [];
  const warnings: string[] = [];

  // Liberia builds use Vite env (e.g. VITE_LIBERIA_API_BASE_URL); API keys live on the server.

  // Check if we're in development mode in production
  if (import.meta.env.DEV && window.location.hostname !== 'localhost') {
    warnings.push('Application is running in development mode on production domain');
  }

  // Check for console.log statements in production
  if (import.meta.env.PROD) {
    // Override console methods to track usage
    const originalLog = console.log;
    let logCount = 0;
    console.log = (...args) => {
      logCount++;
      if (logCount > 10) {
        warnings.push('Excessive console.log usage detected in production');
      }
      originalLog(...args);
    };
  }

  // Check for localStorage availability
  try {
    localStorage.setItem('test', 'test');
    localStorage.removeItem('test');
  } catch (e) {
    warnings.push('localStorage is not available - some features may not work');
  }

  // Check for service worker support
  if (!('serviceWorker' in navigator)) {
    warnings.push('Service workers not supported - offline functionality unavailable');
  }

  return {
    isReady: issues.length === 0,
    issues,
    warnings
  };
};

// Display production readiness on app start
export const displayProductionStatus = () => {
  const status = checkProductionReadiness();
  
  if (!status.isReady) {
    console.error('❌ Production Readiness Check Failed:', status.issues);
  } else {
    console.log('✅ Production Readiness Check Passed');
  }

  if (status.warnings.length > 0) {
    console.warn('⚠️ Production Warnings:', status.warnings);
  }

  return status;
};
